module.exports = __webpack_public_path__ + "img/china_wall.905c2645.jpg";